<template>
     <div class="header fixed-top">
            <nav class="navbar top-navbar navbar-expand-md navbar-light">
                <!-- Logo -->
                <div class="navbar-header">
                    <a class="navbar-brand" href="#">
                        <!-- Logo icon -->
                        <!-- <b><img src="static/assets/images.jpeg" alt="homepage" width="30" height="30" class="dark-logo" /></b> -->
                        <!--End Logo icon -->
                        <!-- Logo text -->
                        <span><img src="static/assets/logo.jpg" alt="homepage"  class="dark-logo" width="200" /></span>
                    </a>
                </div>
                <!-- End Logo -->
                <div class="navbar-collapse">
                    <!-- toggle and nav items -->
                    <ul class="navbar-nav mr-auto mt-md-0">
                       
                      
                        <!-- End Messages -->
                    </ul>
                    <!-- User profile and search -->
                    <ul class="navbar-nav my-lg-0">

                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle text-muted  " href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Welcome {{usernames}} 
                                 <img :src="profileImg === 'N/A' ? 'static/assets/images/avatar_2x.png' :  profileImg !== undefined ? `https://portal.edentransport.co.ke/backend/public/assets/images/${profileImg}` : ''"  style="height: 40px; width: 40px;"  />                                
                                </a>
                            <div class="dropdown-menu dropdown-menu-right animated zoomIn">
                                <ul class="dropdown-user">
                                    <li><router-link to="/profile"><i class="ti-user"></i> Profile</router-link></li>
                                    <li @click="signOut()"><router-link to=""><i class="fa fa-power-off"></i> Logout</router-link></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: mapGetters(["usernames","profileImg"]),
    methods:mapActions(["signOut"])
}
</script>


// WEBPACK FOOTER //
// src/layouts/header.vue